var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconBusinessVehicle64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0425 21.6304H47.1173C47.7593 21.6304 48.3639 21.9322 48.7498 22.4453L55.5898 31.541C55.856 31.8949 55.9999 32.3258 55.9999 32.7686V36.2687H34.0425V21.6304Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0425 35.9282H55.9999V42.0578C55.9999 43.1848 55.0844 44.0984 53.9539 44.0984H34.0425V35.9282Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5532 17.5365C34.5532 16.4134 33.6392 15.5029 32.5137 15.5029H10.0395C8.91315 15.5029 8.00003 16.422 8.00003 17.5365V42.0651C8.00003 43.1882 8.91405 44.0987 10.0395 44.0987H34.5532V17.5365Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.766 25.7157L16.4331 21.3828L12.1002 25.7157L16.4331 30.0486L20.766 25.7157Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.319 49.2049C45.064 49.2049 43.2339 47.3748 43.2339 45.1198C43.2339 42.8621 45.064 41.0347 47.319 41.0347C49.5767 41.0347 51.4041 42.8621 51.4041 45.1198C51.4041 47.3748 49.5767 49.2049 47.319 49.2049Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6808 49.2049C14.4258 49.2049 12.5957 47.3748 12.5957 45.1198C12.5957 42.8621 14.4258 41.0347 16.6808 41.0347C18.9385 41.0347 20.7659 42.8621 20.7659 45.1198C20.7659 47.3748 18.9385 49.2049 16.6808 49.2049Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconBusinessVehicle64);
export default __webpack_public_path__ + "static/media/pictogramBeaconBusinessVehicle64.1498b46ab604b1905f3774309d18f42d.svg";
export { ForwardRef as ReactComponent };